import type { OAuthFunctions, OAuthToken } from 'vue-oidc'

// vue-oidc times expiry from when the answer lands, after the token's own `exp`; a request in that gap is a 401 that signs the user out.
const MARGIN_SECONDS = 60

export const withEarlyExpiry = (token: OAuthToken | undefined) => {
  const seconds = Number(token?.expires_in)
  return token && seconds ? { ...token, expires_in: Math.max(1, seconds - MARGIN_SECONDS) } : token
}

export const expiringEarly = ({ refresh, authorize }: Pick<OAuthFunctions, 'refresh' | 'authorize'>) => ({
  refresh: async (...args: Parameters<OAuthFunctions['refresh']>) => withEarlyExpiry(await refresh(...args)),
  authorize: async (...args: Parameters<OAuthFunctions['authorize']>) => withEarlyExpiry(await authorize(...args))
})
